import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export class PhoneNumberMask {
  public static readonly CONFIG_PLACEHOLDER_CHARACTER = "X";
  public static readonly LOGICAL_PLACEHOLDER_CHARACTER = "0";
  public static readonly SHOWN_PLACEHOLDER_CHARACTER = "_";
  public static readonly PADDING_CHARACTER = "0";

  prefix: string;
  logicalMask: string;
  shownExpression: string;
  specialCharacters: string[];
  valueLength: number;

  constructor(format: string) {
    

    format = format.replace(new RegExp(PhoneNumberMask.CONFIG_PLACEHOLDER_CHARACTER, 'g'), PhoneNumberMask.LOGICAL_PLACEHOLDER_CHARACTER);
    let prefixIndex = format.indexOf(PhoneNumberMask.LOGICAL_PLACEHOLDER_CHARACTER);

    // Prefix is required as there is a bug in ngx-mask for when the
    // first character of the mask is not a placeholder then
    // the user cannot clear the entire input if the field is not
    // completely filled.
    this.prefix = format.substring(0, prefixIndex);
    this.logicalMask = format.substring(prefixIndex);
    this.shownExpression = this.logicalMask.replace(new RegExp(PhoneNumberMask.LOGICAL_PLACEHOLDER_CHARACTER, 'g'), PhoneNumberMask.SHOWN_PLACEHOLDER_CHARACTER);
    this.specialCharacters = format.split('').filter(character => character != PhoneNumberMask.LOGICAL_PLACEHOLDER_CHARACTER && character != PhoneNumberMask.SHOWN_PLACEHOLDER_CHARACTER);
    this.valueLength = this.logicalMask.split('').filter(character => character === PhoneNumberMask.LOGICAL_PLACEHOLDER_CHARACTER).length;
  }

  requiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
     

      return this.isEmpty(control.value) ? { required: true } : null;
    }
  }

  isEmpty(value: string): boolean {
    return this.formatValue(value ?? "").split('').every(character => character === PhoneNumberMask.PADDING_CHARACTER);
  }

  formatValue(value: string, displaySpecialCharacters: boolean = false): string {
    let valueNoSpecialCharacters = (value ?? "").split('').filter(character => !this.specialCharacters.includes(character)).join('');
    let paddedValue = valueNoSpecialCharacters.padEnd(this.valueLength, PhoneNumberMask.PADDING_CHARACTER);

    if (!displaySpecialCharacters) {
      return paddedValue;
    } else {
      let characterIndex = 0;
      let maskedValue = this.prefix + this.logicalMask.replace(new RegExp(PhoneNumberMask.PADDING_CHARACTER, 'g'), () => paddedValue.split('')[characterIndex++]);
      console.log(maskedValue);
      return maskedValue;
    }
  }


}
